<template>

  <div class="pc-page">
    <div class="test_main test_main_2">
      <Nav></Nav>
      <div class="test_step clearfix">
        <router-link to="/learningAbility/learningPotential/guide/91" class="button">Part A</router-link>
        <a href="javascript:;" class="button no">Part B</a>
        <a href="javascript:;" class="button no">Part C</a>
        <a href="javascript:;" class="button no">Part D</a>
      </div>
      <div class="test_test clearfix">
        <div class="test_test_l">
          <div class="titbox center">
            <h4 class="cn_tit">注意力</h4>
            <h6 class="en_tit">Attention</h6>
          </div>
          <div class="desc">
            <p>
              注意力是指心理活动对一定对象的指向和集中的能力。
              注意活动主要包括注意的分配、广度、稳定性和转移四个方面。
            </p>
          </div>
          <div class="notice">
            提示：点击“Part A”进入测试！
          </div>
        </div>
        <div class="test_test_r">
          <img src="~@/assets/09.png" alt="" class="img"/>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="d-relative xgtz-index xgtx-ques">-->
    <!--<img class="block-img" src="../../assets/rzqn/index-bg.jpg" alt="">-->
    <!--<img class="block-img rzqn-block-img" src="../../assets/rzqn/i7.png" alt="">-->
    <!--<Nav></Nav>-->
    <!--<div class="evalu-part">-->
      <!--<router-link to="/rzqn/guide/81">-->
        <!--<img src="../../assets/rzqn/partA-1.png" alt="">-->
        <!--<img src="../../assets/rzqn/partb2.png" alt="">-->
      <!--</router-link>-->
    <!--</div>-->

    <!--<div class="xgtz-intro rzqn-intro">-->
      <!--<img src="../../assets/rzqn/intro-bg.png" alt="">-->
      <!--<div class="i-desc">-->
        <!--<p>-->
          <!--数学能力强的个体，在进行自然科学研究、工程技术研究上表现出一定的优势。-->
        <!--</p>-->
      <!--</div>-->
      <!--<div class="i-tip rzqn-tip">-->
        <!--提示：点击“Part A”进入测试！-->
      <!--</div>-->
    <!--</div>-->


  <!--</div>-->
</template>

<script>
  import Nav from '../../../../components/learningAbility/learningPotential.vue';

  export default {
    data() {
      return {}
    },
    mounted() {
      $('.test_menu .item').eq(8).addClass('item_2');
    },
    updated() {

    },
    components: {Nav},
  }
</script>

<style>
  .evalu-nav {
    background: #333;
    opacity: 1;
  }
</style>
